import * as React from 'react';
import { SaleScreenContext } from './components/SaleScreenContext';
import { SaleWrapper } from './components/SaleWrapper';

interface Props {
  // Overrides the `:id` route param - used when this screen is rendered directly (not via its own
  // `/sales/view/:id` route), e.g. from `ViewDocByMarkScreen` once a mark resolves to one of our
  // own invoices.
  id?: string;
}

export const SaleScreen = ({ id }: Props = {}) => {
  return (
    <SaleScreenContext>
      <SaleWrapper id={id} />
    </SaleScreenContext>
  );
};
